<template>
    <div class="check-box">
        <img v-if="check" class="check-img" src="@/assets/images/icons/checkbox-1.png" />
        <img v-else class="check-img" src="@/assets/images/icons/checkbox-1.png" />
    </div>
</template>
<script>
export default {
   name: 'ocheck',
   props: {
     check:{
       types: Boolean,
       default: false
     }
   },
}
</script>
<style lang="scss" scoped>
.check-img {
  width: 18px;
  height: 18px;
}
.check-box {
  width: 18px;
  height: 18px;
}
</style>